import React from 'react';
import LazyLoadImage from '../../shared/components/lazyload-image';

const defaultIntelBadge = '//www.hp.com/wcsstore/hpusstore/Banners/core-ultra-processor-family-badges.png';
const defaultMessage = ['Intel® Core™ Processors. Intel Inside®.', 'Extraordinary Performance Outside.'];
const getIntelBadge = src => (typeof src === 'string' ? src : defaultIntelBadge);

export default ({
    src,
    alt,
    customMessage = defaultMessage,
    className,
    textPosition = 'postfix',
    loading = 'lazy',
    imgClassName,
}) => {
    let customMessageBlock = Array.isArray(customMessage) && (
        <React.Fragment>
            {customMessage.map((m, i) => (
                <p key={i}>{m}</p>
            ))}
        </React.Fragment>
    );
    const imageUrl = getIntelBadge(src);
    return (
        <div className={`badge-container${className ? ' ' + className : ''}`}>
            {textPosition === 'prefix' && customMessageBlock}
            {loading === 'lazy' ? (
                <LazyLoadImage src={imageUrl} alt={alt} className={imgClassName} />
            ) : (
                <img src={imageUrl} alt={alt} className={imgClassName} />
            )}
            {textPosition === 'postfix' && customMessageBlock}
        </div>
    );
};
